import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { AlertifyService } from '../_services/alertify.service';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ExamService } from '../_services/exam.service';
import { Classification } from '../_models/Classification';

@Injectable()
export class ListClassificationsResolver implements Resolve<Classification[]> {
    constructor(private examService: ExamService, private router: Router,
                private alertify: AlertifyService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Classification[]> {
        return this.examService.getAllClassifications().pipe(
            catchError(error => {
                this.alertify.error('problem retriving data');
                this.router.navigate(['/home']);
                return of(null);
            })
        );
    }
}